import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { gapi } from "./api";

const Ctx = createContext(null);

export function GAuthProvider({ children }) {
  const [state, setState] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await gapi.get("/auth/me");
      setState(data);
    } catch {
      setState(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  useEffect(() => {
    const id = gapi.interceptors.response.use((r) => r, (err) => {
      if (err?.response?.status === 401 && !err.config.url.startsWith("/auth/")) setState(false);
      return Promise.reject(err);
    });
    return () => gapi.interceptors.response.eject(id);
  }, []);

  const logout = async () => {
    try { await gapi.post("/auth/logout"); } finally { setState(false); }
  };

  const can = (risorsa, azione = "visualizzare") =>
    !!state && (state.permessi?.permessi?.[risorsa] || []).includes(azione);

  return <Ctx.Provider value={{ session: state, user: state ? state.user : state, refresh, logout, can }}>{children}</Ctx.Provider>;
}

export const useGAuth = () => useContext(Ctx);
